import { defineStore } from 'pinia'
// import { useStorage } from '@vueuse/core'
import isEmptyObj from '../utils/is-empty-obj'
import { cloneDeep } from 'lodash'

export const useMainStore = defineStore('mainStore', {
  state: () => ({
    ajaxLoading: false,
    filterPopup: false,
    apiData: {},
    // selectedAttributes: useStorage('selectedAttributes', {}),
    // categorySections: useStorage('categorySections', {}),
    // filterQuery: useStorage('filterQuery', ''),
    selectedAttributes: {},
    selectedCategories: {},
    categorySections: {},
    filterQuery: '',
  }),
  getters: {
    filteredSections() {
      if (
        isEmptyObj(this.selectedAttributes) &&
        isEmptyObj(this.selectedCategories) &&
        this.filterQuery === ''
      ) {
        return this.categorySections
      }

      const allCategories = cloneDeep(this.categorySections)
      let selectedCategories = allCategories

      const filters = this.selectedAttributes
      const categories = this.selectedCategories
      const regex = new RegExp(this.filterQuery, 'i')

      const applyCategoryFilter = (category) => {
        if (isEmptyObj(categories)) {
          return category.count
        }

        return category.count && categories.product_cat[category.slug]
      }

      const applySearchFilter = (product) => {
        return regex.test(product.title)
      }

      const applyAttributeFilter = (product) => {
        const productAtts = product.atts
        const hasAtts = Object.keys(productAtts).length

        if (!hasAtts && isEmptyObj(filters)) {
          return true
        }

        let res = false
        for (let attKey in productAtts) {
          const attVals = productAtts[attKey]

          if (!isEmptyObj(filters[attKey])) {
            res = attVals.some(
              (attVal) =>
                filters[attKey] && filters[attKey][attVal.slug] === true
            )
          } else {
            res = attVals.every((attVal) => {
              return (
                !filters[attKey] ||
                filters[attKey][attVal.slug] === false ||
                filters[attKey][attVal.slug] === undefined
              )
            })
          }
        }

        return res
      }

      return selectedCategories
        .map((categorySection) => {
          const filteredProducts = categorySection.products.filter(
            (product) => {
              return applyAttributeFilter(product) && applySearchFilter(product)
            }
          )

          return {
            ...categorySection,
            products: filteredProducts,
            count: filteredProducts.length,
          }
        })
        .filter((categorySection) => applyCategoryFilter(categorySection))
    },
    hasFilter() {
      return (
        !isEmptyObj(this.selectedAttributes) ||
        !isEmptyObj(this.selectedCategories)
      )
    },
  },
  actions: {
    removeFilters() {
      for (const att in this.selectedAttributes) {
        this.selectedAttributes[att] = {}
      }

      for (const att in this.selectedCategories) {
        this.selectedCategories[att] = {}
      }
    },
    removeSearchQuery() {
      this.filterQuery = ''
    },
  },
})
